module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp10-5d06fdbbb1776c92ea3fd4e4946b1afd.jpg";